// Strategy mode definitions shared across the Market Health page.
//
// The mode dropdown that used to live here was removed (2026-08-29): strategy
// selection now happens exclusively through the HeartbeatStrip cards at the
// top of the page. This module is kept as the single source of truth for the
// strategy list, consumed by MarketHealth.js (VALID_MODES / DEFAULT_MODE),
// HeartbeatStrip, SignalDisplay, and the charts.

export const STRATEGY_MODES = [
  { key: 'adaptiveBalanced', label: 'Adaptive', description: 'Balanced multi-factor strategy. Exits when market drops significantly and multiple structural signals align. ~50 trades over 33yr.' },
  { key: 'balanced', label: 'Balanced', description: 'Patient multi-factor strategy. Uses a 4-day sell confirmation window and 3-day re-entry to filter whipsaws. Fewer trades, wider drawdown tolerance.' },
  { key: 'adaptive', label: 'Yield Curve', description: 'Monetary-conditions-focused strategy. Exits when long-term trend breaks and financial conditions signal crash vulnerability. ~40 trades over 33yr.' },
  { key: 'conservative', label: 'Conservative', description: 'Lowest drawdown (-15%). Requires multiple independent structural signals to agree before acting. ~72 trades.' },
];
